import api from "./api_client";

const authService = {
  login: async (username, password) => {
    const response = await api.post("/auth/login", { username, password });
    if (response.data.access_token) {
      localStorage.setItem("smarthr_token", response.data.access_token);
      // Store user info from login response
      const userInfo = {
        id: response.data.user_id,
        email: response.data.email,
        role: response.data.role.toLowerCase()
      };
      localStorage.setItem("smarthr_user", JSON.stringify(userInfo));
    }
    return response.data;
  },

  getMe: async () => {
    const response = await api.get("/auth/me");
    return response.data;
  },

  logout: () => {
    localStorage.removeItem("smarthr_token");
    localStorage.removeItem("smarthr_user");
  },
};

export default authService;
